// actions.js
import axios from 'axios';

// actions
export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const GET_DATA_CUSTOMER = "FETCH_DATA_CUSTOMER";
export const GET_DATA_CUSTOMER_DETAILS ="GET_DATA_CUSTOMER_DETAILS"
export const SET_DATA_DISCONNETION = "SET_DATA_DISCONNETION"
export const GET_DATA_DISCONNETION_RULES = "GET_DATA_DISCONNETION_RULES"
export const GET_DATA_DISCONNETION_RULES_RESET = "GET_DATA_DISCONNETION_RULES_RESET"
export const SET_DATA_DISCONNETION_REMARK = "SET_DATA_DISCONNETION_REMARK"
export const GET_DATA_EVENT = "GET_DATA_EVENT"
export const CLEAR_ALL_DATA = "CLEAR_ALL_DATA"
export const GET_DATA_PENDING_CONNECTION_DETAILS = "GET_DATA_PENDING_CONNECTION_DETAILS"
